var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "my-card", attrs: { header: "通知管理" } },
        [
          _c("p", { staticClass: "tip" }, [
            _vm._v(" 每种类型最多配置三个邮箱，用英文逗号区分 "),
          ]),
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "400",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "财务通知主要是结算，转账，兑换，提现等资金操作行为提示"
                        ),
                      ]),
                      _c(
                        "span",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          _vm._v("财务通知 "),
                          _c("i", { staticClass: "el-icon-warning" }),
                        ]
                      ),
                    ]
                  ),
                  _c("el-input", {
                    attrs: { placeholder: "最多配置三个邮箱，用英文逗号区分" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "400",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "财务通知主要是结算，转账，兑换，提现等资金操作行为提示"
                        ),
                      ]),
                      _c(
                        "span",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          _vm._v("系统通知 "),
                          _c("i", { staticClass: "el-icon-warning" }),
                        ]
                      ),
                    ]
                  ),
                  _c("el-input", {
                    attrs: { placeholder: "最多配置三个邮箱，用英文逗号区分" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "right",
                        width: "400",
                        trigger: "hover",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          "财务通知主要是结算，转账，兑换，提现等资金操作行为提示"
                        ),
                      ]),
                      _c(
                        "span",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          _vm._v("投诉邮件 "),
                          _c("i", { staticClass: "el-icon-warning" }),
                        ]
                      ),
                    ]
                  ),
                  _c("el-input", {
                    attrs: { placeholder: "最多配置三个邮箱，用英文逗号区分" },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("保存"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("p", { staticClass: "mytip1" }, [_vm._v("说明：")]),
          _c("p", { staticClass: "mytip" }, [
            _vm._v("1：每种类型最多配置三个邮箱，用英文逗号区分"),
          ]),
          _c("p", { staticClass: "mytip" }, [
            _vm._v(
              "2：若收件邮件为Gmail邮箱时，平台邮件可能会进入邮件垃圾箱，未收到邮件时，请注意查找"
            ),
          ]),
          _c("p", { staticClass: "mytip" }, [
            _vm._v("3：安全交易验证码邮箱，为登录账户邮箱"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }